import React from 'react'
import { Dialog, DialogContent,DialogTitle,IconButton,Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles';
import { isWeb } from '../../utils/utility';
import Icon from '../../utils/icons';
import { fontClasses } from '../../fontStyles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '0px !important',
    backgroundColor: `${theme.palette.primary.popupBackground} !important`,
    overflow: (props) => props.scrollAllowed ? 'auto' : props.overflow ? 'visible' : 'hidden',
    borderRadius: (props) => props.overflow ? '6px' : '0px'
},
  paper: {
    margin: '45px',
    borderRadius: '10px',
    height: 'auto',
    width: (props) => props.isWeb || isWeb() ? 'auto' : props.dlb ? '300px' : '280px',
    overflow: (props) => props.overflow ? 'visible' : 'auto'
  },
  titleRoot:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom:'1px solid #BABEC3',
    margin: 0,
    padding: '16px 24px',
    boxSizing: 'border-box',
    '& p':{
      ...fontClasses.webtitle1,
      color:'#545456',
      fontWeight:500
    },
    '& svg':{
      width:'20px',
      height:'20px',
      '& path':{
        fill:'#6b7073'
      }
    }
  },
  fixedPaper: {
    position: 'absolute',
    top: '30%',
    bottom: 0,
    left: 0,
    right: 0,
    margin: '0 auto',
    height: 'max-content',
    width: 'max-content'
    },
    popUpRootClass:{
     '& .MuiPaper-root' : {
        backgroundColor: `${theme.palette.primary.popupBackground} !important`,
        maxWidth : isWeb() ?'800px':'max-content',

      },
      
    },
    popUpRootClassschedule:{
      '& .MuiPaper-root' : {
        width:'100%'
      },
    },
    popUpRootClassNewITK:{
    '& .MuiPaper-root' : {
        backgroundColor: `${theme.palette.primary.popupBackground} !important`,
        margin: '0',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100vw',
        maxWidth: '100vw',
        borderRadius: '0 !important',
        height: 'auto',
        maxHeight: '90vh',
        overflowY: 'auto',
      },
    }
}));

function PopUp(props) {
  const classes = useStyles(props)
  return (
    <Dialog
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)', ...(props.zIndex && { zIndex: props.zIndex }) }}
      overlayStyle={{backgroundColor: 'rgba(0, 0, 0, 0.2)'}}
      fullWidth={props.fullWidth}
      open={props.open}
      onClose={props.handleClose}
      disableBackdropClick={props.disableBackdropClick}
      classes={{ paper: props.isFixed ? classes.fixedPaper : classes.paper }}
      className={props.slideFromBottom ? classes.popUpRootClassNewITK : [props.isSchedulePopUp && classes.popUpRootClassschedule,classes.popUpRootClass]}
      title={props.title}
    >
       {props.title && (
    <DialogTitle disableTypography className={classes.titleRoot}>
      <Typography className={classes.titleText}>
        {props.title}
      </Typography>

      <IconButton
        aria-label="close"
        onClick={props.handleClose}
        className={classes.closeButton}
      >
       <Icon src="close"/>
      </IconButton>
    </DialogTitle>
  )}

      <DialogContent classes={{ root: classes.root }}>
        {props.content}
      </DialogContent>
    </Dialog>
  )
}

PopUp.defaultProps = {
  isWeb: false,
  open: false,
  handleClose: null,
  title: '',
  content: <></>,
  disableBackdropClick: false,
  fullWidth: false,
  slideFromBottom: false
}

export default PopUp;